const GlobalConfigIcon = ({ size }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_613_300)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.125 0.5625C5.91758 0.5625 4.9375 1.54258 4.9375 2.75C4.9375 3.95742 5.91758 4.9375 7.125 4.9375C8.33242 4.9375 9.3125 3.95742 9.3125 2.75C9.3125 1.54258 8.33242 0.5625 7.125 0.5625ZM7.125 1.8125C7.64258 1.8125 8.0625 2.23242 8.0625 2.75C8.0625 3.26758 7.64258 3.6875 7.125 3.6875C6.60742 3.6875 6.1875 3.26758 6.1875 2.75C6.1875 2.23242 6.60742 1.8125 7.125 1.8125Z"
          fill="#999999"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.9375 6.8125C3.73008 6.8125 2.75 7.79258 2.75 9C2.75 10.2074 3.73008 11.1875 4.9375 11.1875C6.14492 11.1875 7.125 10.2074 7.125 9C7.125 7.79258 6.14492 6.8125 4.9375 6.8125ZM4.9375 8.0625C5.45508 8.0625 5.875 8.48242 5.875 9C5.875 9.51758 5.45508 9.9375 4.9375 9.9375C4.41992 9.9375 4 9.51758 4 9C4 8.48242 4.41992 8.0625 4.9375 8.0625Z"
          fill="#999999"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.6875 12.75C7.48008 12.75 6.5 13.7301 6.5 14.9375C6.5 16.1449 7.48008 17.125 8.6875 17.125C9.89492 17.125 10.875 16.1449 10.875 14.9375C10.875 13.7301 9.89492 12.75 8.6875 12.75ZM8.6875 14C9.20508 14 9.625 14.4199 9.625 14.9375C9.625 15.4551 9.20508 15.875 8.6875 15.875C8.16992 15.875 7.75 15.4551 7.75 14.9375C7.75 14.4199 8.16992 14 8.6875 14Z"
          fill="#999999"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.5623 3.3752H16.4997C16.8447 3.3752 17.1248 3.09495 17.1248 2.7501C17.1248 2.40525 16.8447 2.125 16.4997 2.125H10.5623C10.2173 2.125 9.93726 2.40525 9.93726 2.7501C9.93726 3.09495 10.2173 3.3752 10.5623 3.3752Z"
          fill="#999999"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.3752 9.62523H16.5002C16.8452 9.62523 17.1252 9.34518 17.1252 9.00012C17.1252 8.65506 16.8452 8.375 16.5002 8.375H8.3752C8.03022 8.375 7.75024 8.65506 7.75024 9.00012C7.75024 9.34518 8.03022 9.62523 8.3752 9.62523Z"
          fill="#999999"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.1252 15.5624H16.5003C16.8453 15.5624 17.1253 15.2824 17.1253 14.9375C17.1253 14.5925 16.8453 14.3125 16.5003 14.3125H12.1252C11.7802 14.3125 11.5002 14.5925 11.5002 14.9375C11.5002 15.2824 11.7802 15.5624 12.1252 15.5624Z"
          fill="#999999"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.49996 15.5625H7.12496C7.46996 15.5625 7.74992 15.2825 7.74992 14.9375C7.74992 14.5925 7.46996 14.3125 7.12496 14.3125H1.49996C1.15496 14.3125 0.875 14.5925 0.875 14.9375C0.875 15.2825 1.15496 15.5625 1.49996 15.5625Z"
          fill="#999999"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.5 9.625H3.375C3.71996 9.625 4 9.345 4 9C4 8.655 3.71996 8.375 3.375 8.375H1.5C1.15504 8.375 0.875 8.655 0.875 9C0.875 9.345 1.15504 9.625 1.5 9.625Z"
          fill="#999999"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.49978 3.375H5.56223C5.9072 3.375 6.18725 3.095 6.18725 2.75C6.18725 2.405 5.9072 2.125 5.56223 2.125H1.49978C1.15481 2.125 0.874756 2.405 0.874756 2.75C0.874756 3.095 1.15481 3.375 1.49978 3.375Z"
          fill="#999999"
        />
      </g>
      <defs>
        <clipPath id="clip0_613_300">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GlobalConfigIcon;
